export const splitOnHighlight = (
  text: string,
  highlight: string,
): { before: string; highlight: string; after: string } => {
  const index = text.indexOf(highlight);
  if (index === -1) return { before: text, highlight: '', after: '' };
  return {
    before: text.slice(0, index),
    highlight,
    after: text.slice(index + highlight.length),
  };
};
